export const FETCH_SITE_VIEW_FILTERS_REQUEST = "FETCH_SITE_VIEW_FILTERS_REQUEST";
export const FETCH_SITE_VIEW_FILTERS_SUCCESS = "FETCH_SITE_VIEW_FILTERS_SUCCESS";
export const FETCH_SITE_VIEW_FILTERS_FAILURE = "FETCH_SITE_VIEW_FILTERS_FAILURE";
export const FETCH_CUSTOMER_SITES_REQUEST = "FETCH_CUSTOMER_SITES_REQUEST";
export const FETCH_CUSTOMER_SITES_SUCCESS = "FETCH_CUSTOMER_SITES_SUCCESS";
export const FETCH_CUSTOMER_SITES_FAILURE = "FETCH_CUSTOMER_SITES_FAILURE";
export const FETCH_SITE_INSTRUMENTS_DATA_REQUEST = "FETCH_SITE_INSTRUMENTS_DATA_REQUEST";
export const FETCH_SITE_INSTRUMENTS_DATA_SUCCESS = "FETCH_SITE_INSTRUMENTS_DATA_SUCCESS";
export const FETCH_SITE_INSTRUMENTS_DATA_FAILURE = "FETCH_SITE_INSTRUMENTS_DATA_FAILURE";
export const SITE_VIEW_DEVICE_DEMOGRAPHICS_FETCH_SUCCESS = "SITE_VIEW_DEVICE_DEMOGRAPHICS_FETCH_SUCCESS";
export const RESET_SITE_INSTRUMENTS_DATA = "RESET_SITE_INSTRUMENTS_DATA";
export const RESET_CUSTOMER_SITES_DATA = "RESET_CUSTOMER_SITES_DATA";
export const FILTER_VALUES_SEL_LIMIT = 500